module.exports = __webpack_public_path__ + "static/img/step_2.9e81110f.png";